import { render, staticRenderFns } from "./common_problems.vue?vue&type=template&id=26144cc6&scoped=true"
import script from "./common_problems.vue?vue&type=script&lang=js"
export * from "./common_problems.vue?vue&type=script&lang=js"
import style0 from "./common_problems.vue?vue&type=style&index=0&id=26144cc6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "26144cc6",
  null
  
)

export default component.exports